// import node module libraries
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// import custom components
import GKAccordionPlus from 'components/marketing/common/accordions/GKAccordionPlus';
import SectionHeadingCenter from 'components/marketing/common/section-headings/SectionHeadingCenter';

// Import Loading Animation
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

// Import translation
import { useTranslation } from 'react-i18next';

const FAQsection = () => {
	const { t } = useTranslation();
	const [FAQList, setFAQList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	const authHeader = useAuthHeader();
	// fetch data from api
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	const getData = async () => {
		setIsLoading(true);
		
		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/public/faqs?faq_categories=general&limit=8`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setFAQList(
					responseData
						? responseData.map(item => ({
							id: item.id,
							title: item.faq_title,
							content: item.faq_content
						}))
						: []
				); // Map the data to match the expected keys
				setIsLoading(false);
			})
			.catch((error) => {
				setIsLoading(false);
			});
	}

	useEffect(() => {
		getData();
	}, []);

	const title = t('Frequently asked questions (FAQ)');
	const subtitle = t('Nice to know');
	const description = t('Here you will find answers to frequently asked questions about our services.');

	return (

		<section className="py-8 py-lg-18 bg-white">
			<Container>
				<SectionHeadingCenter
					title={title}
					description={description}
					subtitle={subtitle}
				/>
				<Row className="justify-content-center">
					<Col lg={6} md={8} sm={12}>
						{isLoading || FAQList && FAQList.length == 0 ? (
							<Skeleton height="40px" count={8} />
						) : (
							FAQList && FAQList.length > 0 && (
								<GKAccordionPlus accordionItems={FAQList} itemClass="px-0" />
							)
						)}
					</Col>
				</Row>
				<div className="mt-10 text-center">
					<span>
						{t('You have additional questions?')}{' '}
					</span>
					<Link to="/marketing/help-center" className="btn btn-outline-primary">
						{t('Open Help Center')}
					</Link>
				</div>
			</Container>
		</section>
	);
};
export default FAQsection;
